import React, { useState } from "react";
import { api, arabicError } from "../lib/api";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ChangePassword = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [loading, setLoading] = useState(false);

  const set = (k, v) => setForm((s) => ({ ...s, [k]: v }));

  const onSubmit = async (e) => {
    e.preventDefault();
    if (form.new_password.length < 6) { toast.error("كلمة المرور الجديدة يجب أن تكون 6 أحرف على الأقل"); return; }
    if (form.new_password !== form.confirm) { toast.error("كلمتا المرور غير متطابقتين"); return; }
    if (form.current_password === form.new_password) { toast.error("كلمة المرور الجديدة يجب أن تختلف عن الحالية"); return; }
    setLoading(true);
    try {
      await api.post("/auth/change-password", {
        current_password: form.current_password,
        new_password: form.new_password,
      });
      toast.success("تم تغيير كلمة المرور بنجاح");
      setForm({ current_password: "", new_password: "", confirm: "" });
      navigate(user.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) { toast.error(arabicError(err)); } finally { setLoading(false); }
  };

  const inputCls = "h-12 w-full rounded-lg border border-[#7AB2B2] bg-white px-4 focus:outline-none focus:ring-2 focus:ring-[#09637E]";

  return (
    <div className="max-w-xl mx-auto space-y-6" data-testid="change-password-page">
      <div>
        <h1 className="text-3xl md:text-4xl font-extrabold text-[#333333]">تغيير كلمة المرور</h1>
        <p className="text-[#666666] mt-1">اختر كلمة مرور قوية لحماية حسابك</p>
      </div>

      <form onSubmit={onSubmit} className="bg-white border border-[#7AB2B2] rounded-2xl p-6 space-y-4" data-testid="change-password-form">
        <div>
          <label className="block text-sm font-bold text-[#333333] mb-1">كلمة المرور الحالية</label>
          <input type="password" required value={form.current_password} onChange={(e) => set("current_password", e.target.value)}
            data-testid="current-password-input" className={inputCls} />
        </div>
        <div>
          <label className="block text-sm font-bold text-[#333333] mb-1">كلمة المرور الجديدة</label>
          <input type="password" required value={form.new_password} onChange={(e) => set("new_password", e.target.value)}
            data-testid="new-password-input" className={inputCls} />
          <p className="text-xs text-[#666666] mt-1">6 أحرف على الأقل</p>
        </div>
        <div>
          <label className="block text-sm font-bold text-[#333333] mb-1">تأكيد كلمة المرور الجديدة</label>
          <input type="password" required value={form.confirm} onChange={(e) => set("confirm", e.target.value)}
            data-testid="confirm-new-password-input" className={inputCls} />
        </div>
        <button type="submit" disabled={loading} data-testid="submit-change-password"
          className="h-12 w-full md:w-auto px-8 rounded-lg bg-[#09637E] hover:bg-[#088395] text-white font-extrabold flex items-center justify-center gap-2 disabled:opacity-60">
          <KeyRound size={18} />
          {loading ? "جارٍ التغيير..." : "تغيير كلمة المرور"}
        </button>
      </form>
    </div>
  );
};

export default ChangePassword;
